// Stable per-forecaster colour assignment for the Trends tab. Identities are
// pseudonymous (user_id / username); we colour by first appearance across the
// leaderboard buckets so a forecaster keeps the same hue in the matrix, the
// trajectory chart, and the trace highlight.

// Muted, desaturated palette that still reads with white cell text and stays
// visually distinct for tracing a forecaster across a row. The Predico brand
// teal (#05788a) is reserved for the ensemble square, so it is absent here.
export const SERIES_PALETTE = [
  '#fb924e', '#3fcaa0', '#5e97f8', '#b873f9', '#f26565',
  '#f7b13b', '#3ccabb', '#8083f4', '#f06bac', '#9bd63f', '#38b6ef',
  '#f66478', '#a079f8', '#2aa6c4', '#ed9326',
];

/**
 * Build a { user_id -> hex } map from a leaderboard-series payload, assigning
 * palette colours in order of first appearance (deterministic for a dataset).
 */
export function buildColorMap(buckets) {
  const map = {};
  let i = 0;
  (buckets || []).forEach((b) => {
    (b.rows || []).forEach((r) => {
      // The ensemble has a fixed colour in the matrix; skip it so it does not
      // consume a palette slot meant for a forecaster.
      if (r.is_ensemble) return;
      if (!(r.user_id in map)) {
        map[r.user_id] = SERIES_PALETTE[i % SERIES_PALETTE.length];
        i += 1;
      }
    });
  });
  return map;
}

// Initials for the dense matrix cell (the per-user colour disambiguates and
// the full identity lives in the hover tooltip). Docker-style usernames are
// `adjective_animal` -> "AA"; single-word fall back to the first two letters.
export function initials(username) {
  if (!username) return '?';
  const parts = username.split(/[_\s-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return username.slice(0, 2).toUpperCase();
}
